export default "__VITE_ASSET__Bpj0b3yz__"